/**
 * ZAETH ESSENTIAL — Hero Section
 * Vanilla JS · entrance, parallax, scroll, mobile mid-nav
 */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAll() {
    document.querySelectorAll('.zaeth-hero').forEach(initHero);
  }

  function initHero(root) {
    if (root.getAttribute('data-zaeth-init') === 'true') return;
    root.setAttribute('data-zaeth-init', 'true');

    requestAnimationFrame(function () {
      root.classList.add('is-ready');
    });

    bindScroll(root);
    bindMenu(root);
    bindSearch(root);
    bindSectionNav(root);

    var parallaxOn = root.getAttribute('data-parallax') === 'true';
    if (parallaxOn && !REDUCED_MOTION && window.matchMedia('(pointer: fine)').matches) {
      initParallax(root);
    }
  }

  function bindScroll(root) {
    var btn = root.querySelector('[data-zaeth-scroll]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var next = root.nextElementSibling;
      var targetY = root.offsetTop + root.offsetHeight;
      if (next) targetY = next.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: targetY,
        behavior: REDUCED_MOTION ? 'auto' : 'smooth'
      });
    });
  }

  /**
   * MENU toggles mobile mid-nav panel (links live behind hamburger on small screens)
   */
  function bindMenu(root) {
    var menuBtn = root.querySelector('[data-zaeth-menu]');
    var mobileNav = root.querySelector('[data-zaeth-mobile-nav]');
    if (!menuBtn) return;

    menuBtn.addEventListener('click', function (e) {
      // Prefer opening in-section mobile nav when present + viewport is mobile
      if (mobileNav && window.matchMedia('(max-width: 989px)').matches) {
        e.preventDefault();
        var open = !mobileNav.classList.contains('is-open');
        setMobileNav(menuBtn, mobileNav, open);
        return;
      }

      // Desktop / no mid-nav: try Dawn drawer, else custom event
      var dawnMenu =
        document.querySelector('header-drawer details') ||
        document.querySelector('#Details-menu-drawer-container') ||
        document.querySelector('.header__icon--menu');

      if (dawnMenu) {
        e.preventDefault();
        var summary =
          dawnMenu.tagName === 'SUMMARY'
            ? dawnMenu
            : dawnMenu.querySelector('summary') || dawnMenu;
        if (summary && typeof summary.click === 'function') {
          summary.click();
          return;
        }
      }

      root.dispatchEvent(
        new CustomEvent('zaeth:menu', {
          bubbles: true,
          detail: { sectionId: root.dataset.sectionId }
        })
      );
    });

    // Close on escape / resize to desktop
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
        setMobileNav(menuBtn, mobileNav, false);
      }
    });

    window.addEventListener(
      'resize',
      function () {
        if (mobileNav && window.matchMedia('(min-width: 990px)').matches) {
          setMobileNav(menuBtn, mobileNav, false);
        }
      },
      { passive: true }
    );
  }

  function setMobileNav(btn, panel, open) {
    panel.classList.toggle('is-open', open);
    btn.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function bindSearch(root) {
    var searchLink = root.querySelector('[data-zaeth-search]');
    if (!searchLink) return;

    searchLink.addEventListener('click', function (e) {
      var details =
        document.querySelector('details-modal.header__search') ||
        document.querySelector('details.header__search');

      if (details) {
        e.preventDefault();
        var summary = details.querySelector('summary');
        if (summary) summary.click();
        else if (details.open !== undefined) details.open = true;
      }
    });
  }

  function bindSectionNav(root) {
    var links = root.querySelectorAll('.zaeth-hero__section-num');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        links.forEach(function (l) {
          l.classList.remove('is-active');
          l.removeAttribute('aria-current');
        });
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'true');
      });
    });
  }

  function initParallax(root) {
    var layers = {
      bg: { el: root.querySelector('[data-parallax-layer="bg"]'), x: 0, y: 0, tx: 0, ty: 0, strength: 8 },
      typo: { el: root.querySelector('[data-parallax-layer="typo"]'), x: 0, y: 0, tx: 0, ty: 0, strength: 14 },
      smoke: { el: root.querySelector('[data-parallax-layer="smoke"]'), x: 0, y: 0, tx: 0, ty: 0, strength: 18 },
      model: { el: root.querySelector('[data-parallax-layer="model"]'), x: 0, y: 0, tx: 0, ty: 0, strength: -10 }
    };

    var rect = null;
    var ticking = false;
    var active = false;

    function measure() {
      rect = root.getBoundingClientRect();
    }

    function onMove(e) {
      if (!rect) measure();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var nx = Math.max(-1, Math.min(1, (e.clientX - cx) / (rect.width / 2)));
      var ny = Math.max(-1, Math.min(1, (e.clientY - cy) / (rect.height / 2)));

      Object.keys(layers).forEach(function (key) {
        var layer = layers[key];
        if (!layer.el) return;
        layer.tx = nx * layer.strength;
        layer.ty = ny * layer.strength * 0.55;
      });

      active = true;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(render);
      }
    }

    function onLeave() {
      Object.keys(layers).forEach(function (key) {
        layers[key].tx = 0;
        layers[key].ty = 0;
      });
      active = true;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(render);
      }
    }

    function render() {
      var stillMoving = false;

      Object.keys(layers).forEach(function (key) {
        var layer = layers[key];
        if (!layer.el) return;

        layer.x += (layer.tx - layer.x) * 0.08;
        layer.y += (layer.ty - layer.y) * 0.08;

        if (Math.abs(layer.tx - layer.x) > 0.05 || Math.abs(layer.ty - layer.y) > 0.05) {
          stillMoving = true;
        }

        if (key === 'model') {
          layer.el.style.transform =
            'translate3d(calc(-50% + ' + layer.x.toFixed(2) + 'px), ' + layer.y.toFixed(2) + 'px, 0)';
        } else if (key === 'typo') {
          layer.el.style.transform =
            'translate3d(' + layer.x.toFixed(2) + 'px, calc(-6% + ' + layer.y.toFixed(2) + 'px), 0)';
        } else {
          layer.el.style.transform =
            'translate3d(' + layer.x.toFixed(2) + 'px, ' + layer.y.toFixed(2) + 'px, 0)';
        }
      });

      ticking = stillMoving || active;
      active = false;
      if (stillMoving) requestAnimationFrame(render);
      else ticking = false;
    }

    measure();
    root.addEventListener('mousemove', onMove, { passive: true });
    root.addEventListener('mouseleave', onLeave, { passive: true });
    window.addEventListener('resize', measure, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) onLeave();
          });
        },
        { threshold: 0.05 }
      );
      io.observe(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector
      ? event.target.querySelector('.zaeth-hero')
      : null;
    if (!hero && event.target.classList && event.target.classList.contains('zaeth-hero')) {
      hero = event.target;
    }
    if (hero) {
      hero.removeAttribute('data-zaeth-init');
      initHero(hero);
    }
  });
})();

/* ==========================================================================
   ZAETH Collection Showcase — append to zaeth-essential.js
   ========================================================================== */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCollections() {
    document.querySelectorAll('.zaeth-col').forEach(initCollection);
  }

  function initCollection(root) {
    if (root.getAttribute('data-zc-init') === 'true') return;
    root.setAttribute('data-zc-init', 'true');
    root.classList.add('is-ready');

    if (REDUCE || root.getAttribute('data-breathing') !== 'true') {
      root.setAttribute('data-breathing', 'false');
    }

    var entrance = root.getAttribute('data-entrance') === 'true' && !REDUCE;

    if (!entrance) {
      root.classList.add('is-inview');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-inview');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-inview');
            io.unobserve(root);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -6% 0px' }
    );

    io.observe(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollections);
  } else {
    initCollections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector
      ? event.target.querySelector('.zaeth-col')
      : null;
    if (!el && event.target.classList && event.target.classList.contains('zaeth-col')) {
      el = event.target;
    }
    if (el) {
      el.removeAttribute('data-zc-init');
      el.classList.remove('is-ready', 'is-inview');
      initCollection(el);
    }
  });
})();

/* Collection drag / touch scroll fix */
(function () {
  'use strict';

  function enableDragScroll(track) {
    if (!track || track.getAttribute('data-zc-drag') === 'true') return;
    track.setAttribute('data-zc-drag', 'true');

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      // Only drag-scroll when track actually overflows (mobile/tablet layout)
      if (track.scrollWidth <= track.clientWidth + 2) return;
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.15;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  function initTracks() {
    document.querySelectorAll('[data-zc-track]').forEach(enableDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracks);
  } else {
    initTracks();
  }

  document.addEventListener('shopify:section:load', initTracks);
})();

/* ==========================================================================
   ZAETH Material Story — append to zaeth-essential.js
   Entrance + optional scroll parallax (no mouse parallax)
   ========================================================================== */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAll() {
    document.querySelectorAll('.zaeth-mat').forEach(initSection);
  }

  function initSection(root) {
    if (root.getAttribute('data-zm-init') === 'true') return;
    root.setAttribute('data-zm-init', 'true');
    root.classList.add('is-ready');

    if (REDUCE) {
      root.setAttribute('data-breathing', 'false');
      root.setAttribute('data-parallax', 'false');
      root.setAttribute('data-anim', 'false');
      root.classList.add('is-inview');
      return;
    }

    var anim = root.getAttribute('data-anim') === 'true';
    if (!anim) {
      root.classList.add('is-inview');
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-inview');
              io.unobserve(root);
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );
      io.observe(root);
    } else {
      root.classList.add('is-inview');
    }

    if (root.getAttribute('data-parallax') === 'true') {
      initScrollParallax(root);
    }
  }

  /** Slow scroll parallax only — mouse disabled by design */
  function initScrollParallax(root) {
    var stage = root.querySelector('[data-zm-stage]');
    if (!stage) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      // progress -1 → 1 while section crosses viewport
      var progress = 1 - (rect.top + rect.height / 2) / (vh / 2 + rect.height / 2);
      progress = Math.max(-1, Math.min(1, progress));
      var y = progress * 18; // very slow / subtle
      stage.style.translate = '0 ' + y.toFixed(2) + 'px';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector
      ? event.target.querySelector('.zaeth-mat')
      : null;
    if (!el && event.target.classList && event.target.classList.contains('zaeth-mat')) {
      el = event.target;
    }
    if (el) {
      el.removeAttribute('data-zm-init');
      el.classList.remove('is-ready', 'is-inview');
      initSection(el);
    }
  });
})();

/* ==========================================================================
   ZAETH Community Gallery
   Append to assets/zaeth-essential.js
   Vanilla JS — no jQuery, no GSAP
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[data-zaeth-community]';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function parseJSON(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  function CommunityGallery(section) {
    this.section = section;
    this.gallery = section.querySelector('[data-zc-gallery]');
    this.items = Array.prototype.slice.call(section.querySelectorAll('[data-zc-item]'));
    this.hoverEnabled = section.getAttribute('data-hover') === 'true';
    this.lightboxEnabled = section.getAttribute('data-lightbox') === 'true';
    this.lightbox = section.querySelector('[data-zc-lightbox]');
    this.lightboxData = [];
    this.activeIndex = 0;
    this.lastFocus = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    this.onKeydown = this.onKeydown.bind(this);
    this.onLightboxTouchStart = this.onLightboxTouchStart.bind(this);
    this.onLightboxTouchEnd = this.onLightboxTouchEnd.bind(this);

    this.init();
  }

  CommunityGallery.prototype.init = function () {
    this.initAnimations();
    this.initHoverProductButtons();
    this.initTriggers();

    if (this.lightboxEnabled && this.lightbox) {
      this.initLightbox();
    }
  };

  /* ----------------------------------------------------------------------
     Entrance — Intersection Observer + stagger
     ---------------------------------------------------------------------- */

  CommunityGallery.prototype.initAnimations = function () {
    var targets = this.section.querySelectorAll('[data-zc-animate]');
    if (!targets.length) return;

    if (REDUCED_MOTION.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.15,
      }
    );

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);
    });
  };

  /* ----------------------------------------------------------------------
     Optional View Product — stop lightbox when clicking product CTA
     ---------------------------------------------------------------------- */

  CommunityGallery.prototype.initHoverProductButtons = function () {
    if (!this.hoverEnabled) return;

    Array.prototype.forEach.call(
      this.section.querySelectorAll('.zaeth-community__view[data-zc-product]'),
      function (link) {
        link.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }
    );
  };

  /* ----------------------------------------------------------------------
     Image triggers
     ---------------------------------------------------------------------- */

  CommunityGallery.prototype.initTriggers = function () {
    var self = this;

    Array.prototype.forEach.call(
      this.section.querySelectorAll('[data-zc-trigger]'),
      function (trigger) {
        trigger.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-zc-product]')) return;

          var item = trigger.closest('[data-zc-item]');
          if (!item) return;

          var index = parseInt(item.getAttribute('data-zc-index'), 10) || 0;

          if (self.lightboxEnabled && self.lightbox) {
            self.openLightbox(index);
            return;
          }

          var product = item.querySelector('[data-zc-product]');
          if (product && product.getAttribute('href')) {
            window.location.href = product.getAttribute('href');
          }
        });
      }
    );
  };

  /* ----------------------------------------------------------------------
     Lightbox
     ---------------------------------------------------------------------- */

  CommunityGallery.prototype.initLightbox = function () {
    var self = this;
    var dataNode = this.lightbox.querySelector('[data-zc-lightbox-data]');
    this.lightboxData = parseJSON(dataNode);

    this.img = this.lightbox.querySelector('[data-zc-lightbox-img]');
    this.userEl = this.lightbox.querySelector('[data-zc-lightbox-user]');
    this.textEl = this.lightbox.querySelector('[data-zc-lightbox-text]');

    Array.prototype.forEach.call(
      this.lightbox.querySelectorAll('[data-zc-lightbox-close]'),
      function (el) {
        el.addEventListener('click', function () {
          self.closeLightbox();
        });
      }
    );

    var prev = this.lightbox.querySelector('[data-zc-lightbox-prev]');
    var next = this.lightbox.querySelector('[data-zc-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { self.showLightbox(self.activeIndex - 1); });
    if (next) next.addEventListener('click', function () { self.showLightbox(self.activeIndex + 1); });

    this.lightbox.addEventListener('touchstart', this.onLightboxTouchStart, { passive: true });
    this.lightbox.addEventListener('touchend', this.onLightboxTouchEnd, { passive: true });
  };

  CommunityGallery.prototype.openLightbox = function (index) {
    if (!this.lightbox || !this.lightboxData.length) return;

    this.lastFocus = document.activeElement;
    this.lightbox.hidden = false;
    // Force reflow so transition runs
    void this.lightbox.offsetWidth;
    this.lightbox.classList.add('is-open');
    lockScroll(true);
    this.showLightbox(index);
    document.addEventListener('keydown', this.onKeydown);

    var closeBtn = this.lightbox.querySelector('[data-zc-lightbox-close]');
    if (closeBtn) closeBtn.focus();
  };

  CommunityGallery.prototype.closeLightbox = function () {
    if (!this.lightbox) return;

    this.lightbox.classList.remove('is-open');
    lockScroll(false);
    document.removeEventListener('keydown', this.onKeydown);

    var self = this;
    window.setTimeout(function () {
      if (!self.lightbox.classList.contains('is-open')) {
        self.lightbox.hidden = true;
      }
    }, 320);

    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus();
    }
  };

  CommunityGallery.prototype.showLightbox = function (index) {
    if (!this.lightboxData.length) return;

    var total = this.lightboxData.length;
    this.activeIndex = ((index % total) + total) % total;

    var item = this.lightboxData[this.activeIndex];
    if (!item || !this.img) return;

    this.img.removeAttribute('srcset');
    this.img.alt = item.alt || item.username || '';
    if (item.srcset) this.img.srcset = item.srcset;
    this.img.sizes = '(max-width: 989px) 92vw, 920px';
    this.img.src = item.src || '';

    if (this.userEl) this.userEl.textContent = item.username || '';
    if (this.textEl) this.textEl.textContent = item.caption || '';
  };

  CommunityGallery.prototype.onKeydown = function (e) {
    if (!this.lightbox || !this.lightbox.classList.contains('is-open')) return;

    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        this.closeLightbox();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        this.showLightbox(this.activeIndex - 1);
        break;
      case 'ArrowRight':
        e.preventDefault();
        this.showLightbox(this.activeIndex + 1);
        break;
      default:
        break;
    }
  };

  CommunityGallery.prototype.onLightboxTouchStart = function (e) {
    if (!e.changedTouches || !e.changedTouches.length) return;
    this.touchStartX = e.changedTouches[0].clientX;
    this.touchDeltaX = 0;
  };

  CommunityGallery.prototype.onLightboxTouchEnd = function (e) {
    if (!e.changedTouches || !e.changedTouches.length) return;
    this.touchDeltaX = e.changedTouches[0].clientX - this.touchStartX;

    if (Math.abs(this.touchDeltaX) < 50) return;

    if (this.touchDeltaX > 0) {
      this.showLightbox(this.activeIndex - 1);
    } else {
      this.showLightbox(this.activeIndex + 1);
    }
  };

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */

  function initAll() {
    var sections = document.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(sections, function (section) {
      if (section.__zaethCommunityInit) return;
      section.__zaethCommunityInit = true;
      new CommunityGallery(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector(SELECTOR) || (e.target.matches && e.target.matches(SELECTOR) ? e.target : null)
      : null;

    if (!section && e.target && e.target.id) {
      section = document.querySelector('#ZaethCommunityGallery-' + String(e.target.id).replace('shopify-section-', ''));
    }

    // Re-scan after Theme Editor section load
    window.setTimeout(initAll, 0);
  });

  document.addEventListener('shopify:section:unload', function () {
    lockScroll(false);
  });
})();

/* ==========================================================================
   ZAETH Universal Footer
   Append to assets/zaeth-essential.js
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[data-zaeth-footer]';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function ZaethFooter(root) {
    this.root = root;
    this.animate = root.getAttribute('data-animate') === 'true';
    this.init();
  }

  ZaethFooter.prototype.init = function () {
    this.indexColumns();
    this.initEntrance();
    this.initAccordions();
    this.initSuccessFocus();
    this.bindResize();
  };

  ZaethFooter.prototype.indexColumns = function () {
    var cols = this.root.querySelectorAll('[data-zf-col]');
    Array.prototype.forEach.call(cols, function (col, i) {
      col.style.setProperty('--zf-i', String(i));
    });
  };

  ZaethFooter.prototype.initEntrance = function () {
    var targets = this.root.querySelectorAll('[data-zf-animate]');
    if (!targets.length) return;

    if (!this.animate || REDUCED.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -6% 0px', threshold: 0.12 }
    );

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);
    });
  };

  ZaethFooter.prototype.initAccordions = function () {
    var buttons = this.root.querySelectorAll('[data-zf-accordion]');

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        if (!MOBILE_MQ.matches) return;

        var expanded = btn.getAttribute('aria-expanded') === 'true';

        Array.prototype.forEach.call(buttons, function (other) {
          if (other === btn) return;
          other.setAttribute('aria-expanded', 'false');
          var otherCol = other.closest('.zaeth-footer__col--nav');
          if (otherCol) otherCol.classList.remove('is-open');
        });

        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var col = btn.closest('.zaeth-footer__col--nav');
        if (col) col.classList.toggle('is-open', !expanded);
      });
    });

    this.syncAccordionState();
  };

  ZaethFooter.prototype.syncAccordionState = function () {
    var buttons = this.root.querySelectorAll('[data-zf-accordion]');
    var isMobile = MOBILE_MQ.matches;

    Array.prototype.forEach.call(buttons, function (btn) {
      var col = btn.closest('.zaeth-footer__col--nav');
      if (!isMobile) {
        btn.setAttribute('aria-expanded', 'false');
        if (col) col.classList.remove('is-open');
      }
    });
  };

  ZaethFooter.prototype.bindResize = function () {
    var self = this;
    var timer = null;
    var onChange = function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        self.syncAccordionState();
      }, 120);
    };

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', onChange);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(onChange);
    }
  };

  ZaethFooter.prototype.initSuccessFocus = function () {
    var success = this.root.querySelector('[data-zf-success]');
    if (!success) return;
    window.setTimeout(function () {
      try { success.focus(); } catch (e) {}
    }, 50);
  };

  function boot() {
    var nodes = document.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.__zaethFooterInit) return;
      node.__zaethFooterInit = true;
      new ZaethFooter(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });
})();